<script>
export default {
  props: {
    module: Object,
    value: String,
  },
  data: () => ({
    min: new Date(),
    max: new Date(),
  }),
  methods: {
    handlerUpdateDate(value) {
      const date = new Date(this.module.date);
      date.setMonth(date.getMonth() + value);
      this.module.date = date;
      this.module.get();
    },
    handlerClick(item) {
      if (!item || !item.id) {
        return;
      }
      this.$emit('click', item.id);
    },
  },
  mounted() {
    this.min = new Date();
    this.min.setDate(2);
    this.max = new Date();
    this.max.setMonth(this.max.getMonth() + 6);
  },
};
</script>
<template>
  <CardCalendar
    v-if="module"
    title="Календарь"
    :options="module.items"
    :date="module.date"
    @next="handlerUpdateDate(+1)"
    @prev="handlerUpdateDate(-1)"
    :loading="module.loading"
    :min="min"
    :max="max"
    @click="handlerClick"
    class="p-t-c-id"
  >
    <div slot-scope="{item}" v-if="item">
      <span v-if="item.price">
      {{ item.price | price }} {{ 'rub' | currency }}
      </span>
    </div>
  </CardCalendar>
</template>
<style lang="scss">
  .p-t-c-id {
    &__list {
      display: flex;
      flex-wrap: wrap;
    }

    &__item {
      margin: 4px;
      padding: 4px;
      border-radius: 4px;
      text-align: center;
      line-height: 18px;
      background: #1b2f3f22;
      cursor: pointer;

      span {
        display: inline-block;
        width: 100%;
        font-size: 12px;
        text-transform: uppercase;
        line-height: 14px;
      }

      &:hover {
        background: #1b2f3f66;
      }

      &--active {
        background: #1b2f3f;
        color: #fff;

        &:hover {
          background: #1b2f3f;
        }
      }

      &--disabled {
        background: #f5f5f5;
        color: #999999;
        cursor: not-allowed;

        &:hover {
          background: #f5f5f5;
          color: #999999;
        }
      }
    }

    &__name {
      font-size: 18px;
      margin-bottom: 4px;
      font-weight: 700;
    }

    &__price {
    }
  }

  @media (max-width: 700px) {
    .p-t-c-id {
      .card-calendar__slot {
        display: none;
      }

      .card-calendar__name {
        text-align: center;
        margin: 0;
      }
    }
  }

  @media (max-width: 500px) {
    .p-t-c-id {
      .card-calendar__name {
        font-size: 14px;
      }

      .card-title {
        display: block;
      }

      .card-calendar__month {
        flex: 1;
      }
      .card-title__btn{
        margin-top: 8px;
      }
    }
  }

  @media (max-width: 350px) {
    .p-t-c-id {
      .card-calendar__name {
        font-size: 12px;
      }
      .card-calendar__item{
        padding: 4px 0;
      }
    }
  }
</style>
